import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMortarPestle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "110px",
	height: "120px",
	viewBox: "0 0 110 120",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "noun_Mortar Pestle_1932906" }), /* @__PURE__ */ _jsx("g", {
		id: "Labor-Day",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			transform: "translate(-672.000000, -145.000000)",
			fill: "currentcolor",
			fillRule: "nonzero",
			id: "noun_Mortar-Pestle_1932906",
			children: /* @__PURE__ */ _jsxs("g", {
				transform: "translate(672.000000, 145.000000)",
				id: "Group",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M10.8185012,47 C15.5685012,44.25 29.0685012,39 52.8185012,38.75 L36.5685012,54 C22.5685012,52.5 14.3185012,49.25 10.8185012,47 Z",
						id: "Path"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M85.0685012,104.25 C73.0685012,125.25 36.5685012,125.25 24.5685012,104.25 C42.8185012,116.25 66.8185012,116.25 85.0685012,104.25 Z",
						id: "Path"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M98.8185012,47 C95.0685012,49.5 85.0685012,53.25 69.0685012,54.5 L81.5685012,41.25 C90.3185012,43 96.0685012,45.25 98.8185012,47 Z",
						id: "Path"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M87.5685012,12.5 C86.8185012,9.25 87.5685012,5.5 90.3185012,3 C94.3185012,-1 100.818501,-1 104.568501,3 C108.568501,7 108.568501,13.25 104.568501,17.25 C102.068501,19.75 98.3185012,20.75 95.0685012,20 C94.8185012,20.25 71.8185012,44.75 62.3185012,55 C55.3185012,55.25 48.3185012,55.25 42.3185012,54.75 C52.3185012,45.5 77.3185012,22 87.5685012,12.5 Z",
						id: "Path"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M85.0685012,99.75 C66.8185012,112 42.8185012,111.75 24.5685012,99.75 C6.56850116,87.75 -2.43149884,66.5 0.568501159,46.25 L0.568501159,46.5 C1.56850116,32.25 46.5685012,29.25 62.3185012,30 L57.5685012,34.25 C38.5685012,33.75 7.31850116,39 5.06850116,46.5 L5.06850116,46.5 L5.06850116,46.75 C6.06850116,63.5 104.818501,63 104.818501,46.75 C104.318501,44 97.5685012,40 85.0685012,37.25 L88.5685012,33.5 C103.068501,37 109.568501,42.25 109.318501,47.25 C111.818501,67.5 102.568501,88 85.0685012,99.75 Z",
						id: "Path"
					})
				]
			})
		})
	})]
});
export default SvgMortarPestle;
